import { printSkillsPdf } from "../Actions";
import {
  ADD_SKILL_SET_SUCCESS,
  FETCH_ALL_SKILL_SET_SUCCESS,
  EMPTY_SKILL_SET,
  RESTORE_SKILL_SET_INITIAL,
  ACTIVATE_SKILL_SET_SUCCESS,
  DEACTIVATE_SKILL_SET_SUCCESS,
  FETCH_SKILL_SET_BY_ID_SUCCESS,
  EMPTY_SKILL_SET_BY_ID,
  CREATE_SUBSKILL_SUCCESS,
  FETCH_SUBSKILL_BY_SKILL_ID_SUCCESS,
  EMPTY_SUBSKILL_BY_SKILL_ID_SUCCESS,
  FETCH_ALL_TOTAL_SKILLS_DATA_SUCCESS,
  UPDATE_SKILL_SET_SUCCESS,

  UPDATE_SUB_SKILL,
  UPDATE_SUB_SKILL_SUCCESS,
  UPDATE_SUB_SKILL_FAILURE,
  RESET_UPDATE_SUB_SKILL,

  EMPTY_TOTAL_SKILL_SET,
  FETCH_SKILLCENTRES_BY_STATE_SUCCESS,
  EMPTY_SKILLCENTRES_BY_STATE,
  EXPORT_SKILLS_SUCCESS,
  PRINT_SKILLS_SUCCESS,
  UPDATE_MULTIPLE_SUB_SKILLS_SUCCESS,
  IMPORT_SKILL_SET_SUCCESS,
  IMPORT_SUB_SKILL_SUCCESS,
} from "../ActionTypes";

const INIT_STATE = {
  skillSetCreated: false,
  subSkillsCreated: false,
  allSkillSetCreated: {},
  skillSetActivated: false,
  skillSetDeactivated: false,
  skillSet: {},
  totalSkillSetData: {},
  subSkillsBySkillId: [],
  skillSetUpdated: false,
  multipleSubSkillUpdated: false,
  skillCentresByStateId: [],
  isLoading: true,
  skillsCSV: false,
  skillsPDF: false,
  bulkUploadData:false,
  subSkillBulkUploadData:false,

  savingSubskillUpdate: false,
  subSkillUpdateSuccess: false,
};

function reducers(state = INIT_STATE, action) {
  switch (action.type) {
    case ADD_SKILL_SET_SUCCESS: {
      return {
        ...state,
        skillSetCreated: true,
      };
    }
    case FETCH_ALL_SKILL_SET_SUCCESS: {
      return {
        ...state,
        allSkillSetCreated: action.payload,
        isLoading: false,
      };
    }
    case EMPTY_SKILL_SET: {
      return {
        ...state,
        allSkillSetCreated: {},
      };
    }
    case RESTORE_SKILL_SET_INITIAL: {
      return {
        ...state,
        skillSetCreated: false,
        skillSetActivated: false,
        skillSetDeactivated: false,
        subSkillsCreated: false,
        skillSetUpdated: false,
        subSkillUpdated: false,
        isLoading: true,
        multipleSubSkillUpdated:false,
        bulkUploadData:false,
        subSkillBulkUploadData:false
      };
    }

    case ACTIVATE_SKILL_SET_SUCCESS: {
      return {
        ...state,
        skillSetActivated: true,
      };
    }
    case DEACTIVATE_SKILL_SET_SUCCESS: {
      return {
        ...state,
        skillSetDeactivated: true,
      };
    }
    case FETCH_SKILL_SET_BY_ID_SUCCESS: {
      return {
        ...state,
        skillSet: action.payload,
      };
    }
    case EMPTY_SKILL_SET_BY_ID: {
      return {
        ...state,
        skillSet: {},
      };
    }
    case CREATE_SUBSKILL_SUCCESS: {
      return {
        ...state,
        subSkillsCreated: true,
      };
    }
    case FETCH_SUBSKILL_BY_SKILL_ID_SUCCESS: {
      return {
        ...state,
        subSkillsBySkillId: action.payload,
      };
    }
    case EMPTY_SUBSKILL_BY_SKILL_ID_SUCCESS: {
      return {
        ...state,
        subSkillsBySkillId: [],
      };
    }
    case FETCH_ALL_TOTAL_SKILLS_DATA_SUCCESS: {
      return {
        ...state,
        totalSkillSetData: action.payload,
        isLoading: false,
      };
    }
    case UPDATE_SKILL_SET_SUCCESS: {
      return {
        ...state,
        skillSetUpdated: true,
      };
    }
    case UPDATE_SUB_SKILL: {
      return {
        ...state,
        savingSubskillUpdate: true,
      }
    }
    case UPDATE_SUB_SKILL_SUCCESS: {
      return {
        ...state,
        subSkillUpdated: true,
        savingSubskillUpdate: false
      };
    }
    case UPDATE_SUB_SKILL_FAILURE: {
      return {
        ...state,
        subSkillUpdated: false,
        savingSubskillUpdate: false
      }
    }
    case RESET_UPDATE_SUB_SKILL: {
      return {
        ...state,
        subSkillUpdated: false,
        savingSubskillUpdate: false
      }
    }
    case UPDATE_MULTIPLE_SUB_SKILLS_SUCCESS:{
      return{
        ...state,
        multipleSubSkillUpdated:true,
      }
    }
    case EMPTY_TOTAL_SKILL_SET: {
      return {
        ...state,
        totalSkillSetData: {},
      };
    }
    case FETCH_SKILLCENTRES_BY_STATE_SUCCESS: {
      return {
        ...state,
        skillCentresByStateId: action.payload,
      };
    }
    case EMPTY_SKILLCENTRES_BY_STATE: {
      return {
        ...state,
        skillCentresByStateId: [],
      };
    }
    case EXPORT_SKILLS_SUCCESS: {
      return {
        ...state,
        skillsCSV: action.payload,
      };
    }
    case PRINT_SKILLS_SUCCESS:{
      return{
      ...state,
      printSkillsPdf: action.payload,
      }
    }
    case IMPORT_SKILL_SET_SUCCESS:{
      return{
      ...state,
      bulkUploadData: true,
      }
    } 
    case IMPORT_SUB_SKILL_SUCCESS:{
      return{
      ...state,
      subSkillBulkUploadData: true,
      }
    }
    default:
      return state;
  }
}

export default reducers;
